import { Text } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
import { Box } from "@react-three/flex";
import PagePosition from "../../Position/PagePosition";

function TxtFlex({
  posX, 
  posY, 
  align,
  justify, 
  text,
  textTwo,
  txtColorOne,
  txtColorTwo, 
  textAlign, 
  textScaleFactor, 
  onReflow, 
  width,
  marginRight
}) {
  const { viewport } = useThree();
  

  return (
    <Box 
      flexDirection='column' 
      align={align} 
      justify={justify}
      width={width}
      height='auto'
    >
      <Box
        marginRight={marginRight}
      >
        <Text            
          bold
          position-z={0.5}
          position-x={posX}
          position-y={posY}
          textAlign={textAlign}
          fontSize={textScaleFactor}
          lineHeight={1}
          letterSpacing={-0.05}
          color={txtColorOne}
          maxWidth={(viewport.width / 4) * 3}
        >
          {text}
        </Text>
      </Box>
      {textTwo ? 
      <Box>
        <Text            
          bold
          position-z={0.5}
          position-x={posX}
          position-y={posY}
          textAlign={textAlign}
          fontSize={textScaleFactor}
          lineHeight={1}
          letterSpacing={-0.05}
          color={txtColorTwo}
          maxWidth={(viewport.width / 4) * 3}
          >
          {textTwo}
        </Text>
      </Box>
      : null}
      </Box>
  );
};

export default TxtFlex;